
	export default {
		name: "LoaderButton",

		props: {
			loading: Boolean,
			small: Boolean,
		},
	};
